import { Trans } from '@lingui/react/macro';
import { FilterButton } from '@pocketlaw/tetris';
import { SelectProjectsMenu } from 'app/domains/projects';
import { useFilter } from '../useFilter';
export function MultiselectOperator(props) {
    var _a, _b;
    const { projects, name: filterName } = props;
    const filter = useFilter(filterName);
    const selectedIds = (((_a = filter.value) === null || _a === void 0 ? void 0 : _a[filter.operator]) || []);
    const [firstSelection] = selectedIds || [];
    const secondaryCount = selectedIds.length > 1 ? `+${selectedIds.length - 1}` : '';
    const selectedTitle = (_b = projects.find((project) => project.id === firstSelection)) === null || _b === void 0 ? void 0 : _b.name;
    const secondaryText = selectedIds.length ? `${selectedTitle} ${secondaryCount}` : '';
    const selectedProjectIds = projects.map((project) => project.id);
    const selectProject = (project) => {
        const { id } = project;
        const selected = selectedIds.includes(id);
        if (!selected) {
            const newData = { [filter.operator]: [...selectedIds, id] };
            filter.setValue(newData);
            return;
        }
        if (selectedIds.length === 1) {
            filter.resetValue();
        }
        else {
            const newData = {
                [filter.operator]: selectedIds.filter((selectedItem) => selectedItem !== id),
            };
            filter.setValue(newData);
        }
    };
    return (<SelectProjectsMenu renderTarget={<FilterButton type="button" appearance={filter.isTouched ? 'draft' : 'default'}>
          {secondaryText || <Trans comment="Multi select filter button">Select value</Trans>}
        </FilterButton>} selectedProjectIds={selectedProjectIds} onSelect={selectProject}/>);
}
